import { EntityDetail } from '@/common/entityFramework/entityDetail/EntityDetail';
import { EntityForm } from '@/common/entityFramework/entityForm/EntityForm';
import { useEntityMgr } from '@/common/entityFramework/entityView/EntityMgrContext';
import { AbvPriceActionPctList } from './AbvPriceActionPctList';

export const AbvPriceActionPctGrpDetail = () => {

    const { entityObj } = useEntityMgr();

    const tabSpecs = [
        { id: 'infoTab', label: 'Info', content: <EntityForm /> },
        { id: 'priceActionPctTab', label: 'Percentages', content: <AbvPriceActionPctList priceActionPctGrpId={entityObj?.id} /> }
    ];

    return (
        <EntityDetail tabSpecs={tabSpecs} />
    );
}